<template>
  <el-form :model="mcoupon_data" :rules="couponRules" ref="couponRef" label-width="180px" label-position="right"
    style="padding:20px 0 20px 0">
    <!--<el-form-item label="店铺logo：" style="height:100px">
       <logo :wh="'height:100px;width:100px;background-color:#80c4ff;font-size:20px'" :tag="'logo'" :uploadWx="true"
        @getReturn="getReturn" @returnClose="returnClose">
        LOGO
      </logo>
      <pre style="display:inline-block;margin-left:110px;margin-top:-10px;">
        1、大小需为120像素*120像素。
        2、支持JPG/JPEG/PNG格式，且图片小于1M。
        3、可以不上传
      </pre>
    </el-form-item> -->
    <el-form-item label="店铺名称：">
      <el-input v-model="mcoupon_data.merchant_name" maxlength="12" show-word-limit placeholder=""></el-input>
      <span style="display:inline-block;margin-left:20px">
        填写店铺名称
      </span>
    </el-form-item>
    <el-form-item label="批次名称：" style="margin-top:40px">
      <el-input v-model="mcoupon_data.coupon_name" maxlength="21" show-word-limit placeholder="如：11月11日活动券"></el-input>
      <span style="display:inline-block;margin-left:20px">
        该代金卷的批次名称
      </span>
    </el-form-item>
    <el-form-item label="适用商品范围：" style="margin-top:40px">
      <el-input v-model="mcoupon_data.goods_name" maxlength="15" show-word-limit placeholder="如：微信支付代金卷"></el-input>
      <span style="display:inline-block;margin-left:20px">
        卷的适用范围（如：可口可乐可用）
      </span>
    </el-form-item>
    <el-form-item label="是否长期有效：">
      <el-radio-group @change="radioChange($event, 'time')" v-model="other_data.longtime_radio"><el-radio
          label="0">自选日期</el-radio>
        <el-radio label="1">长期有效</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="核销卷时间：">
      <el-col :span="10">
        <div id="date-div">
          <el-date-picker :disabled="other_data.longtime_radio == '1'" v-model="mcoupon_data.start_time" type="datetime"
            @change="getDate($event, 'start_time')" placeholder="选择开始日期和时间">
          </el-date-picker>
        </div>
      </el-col>
      <el-col :span="5">
        <div id="date-div">
          <el-date-picker :disabled="other_data.longtime_radio == '1'" v-model="mcoupon_data.expire_time"
            type="datetime" @change="getDate($event, 'expire_time')" placeholder="选择截止日期和时间">
          </el-date-picker>
        </div>
      </el-col>
    </el-form-item>
    <el-form-item label="卷类型：">
      <el-radio-group disabled v-model="mcoupon_data.stock_type" @change="stockTypeChange">
        <el-radio :label="'NORMAL'">满减卷</el-radio>
        <el-radio :label="'DISCOUNT'">折扣卷</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="满减卷使用规则：" v-if="mcoupon_data.stock_type == 'NORMAL'">
      满&nbsp;&nbsp;<el-input style="width:100px !important"
        v-model="mcoupon_data.amount_require"></el-input>&nbsp;&nbsp; 元，可抵用&nbsp;&nbsp;
      <el-input style="width:100px !important" v-model="mcoupon_data.amount"></el-input>&nbsp;&nbsp;元
    </el-form-item>
    <el-form-item label="折扣卷使用规则：" v-if="mcoupon_data.stock_type == 'DISCOUNT'">
      满&nbsp;&nbsp;<el-input style="width:100px !important"
        v-model="mcoupon_data.amount_require"></el-input>&nbsp;&nbsp; 元，可享&nbsp;&nbsp;
      <el-input style="width:100px !important" v-model="mcoupon_data.discount_percent"></el-input>&nbsp;&nbsp;折优惠
    </el-form-item>
    <el-form-item label="发卷数量：">
      <el-input max="1000000000" min="1" style="width:100px !important"
        v-model="mcoupon_data.max_coupons"></el-input>&nbsp;&nbsp;张
    </el-form-item>
    <el-form-item label="用户最多可领：">
      <el-input max="100" min="1" style="width:100px !important"
        v-model="mcoupon_data.max_coupons_per_user"></el-input>&nbsp;&nbsp;张</el-form-item>
    <el-form-item label="">
      <el-button type="primary">保存并生成优惠卷</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
/* eslint-disable */
import { createWxMCoupon, upLoadWxCode } from "@/api/index";
import { GetDateTime } from "@/js/public.js";
import {
  getGeneralCouponInfo
} from "../js/couponInfo.js";
import logo from "@/components/logo.vue";
export default {
  name: "createCouponFrom",
  components: {
    logo
  },
  props: ["coupon_data"],
  data() {
    return {
      mcoupon_data: {
        merchant_name: "",
        coupon_name: "",
        goods_name: "全部商品可用，特价商品除外",
        start_time: GetDateTime(0, new Date()),
        expire_time: GetDateTime(7, new Date()),
        stock_type: "NORMAL",
        amount_require: "", //使用门槛
        amount: "", //折扣金额
        discount_percent: "", //折扣比例
        max_coupons: "999999", //发卷数量
        max_coupons_per_user: "100" //最多可领取数量
      },
      other_data: {
        longtime_radio: "0"
      },
      couponRules: {
        activity_name: [
          { required: true, message: "请输活动名称", trigger: "blur" }
        ],
        start_time: [
          { required: true, message: "请选择活动时间", trigger: "change" }
        ],
        activity_title: [
          { required: true, message: "请设置活动标题", trigger: "blur" }
        ],
        img_logo: [
          { required: true, message: "请设置店铺logo", trigger: "change" }
        ],
        img_activity: [
          { required: true, message: "请上传活动宣传图", trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  mounted() {
    this.mcoupon_data = getGeneralCouponInfo(this.coupon_data);//获取卷信息
    console.log("卷信息", this.mcoupon_data);
    /* console.log("cccccccccccccccccccccccccccccc", this.coupon_data);
    this.mcoupon_data.stock_type = this.coupon_data.stock_type;
    this.mcoupon_data.coupon_name = this.coupon_data.coupon_name;
    this.mcoupon_data.amount_require = this.coupon_data.value2 / 100;
    this.mcoupon_data.amount = this.coupon_data.value1 / 100;
    if (localStorage.getItem("merchant_name")) {
      this.mcoupon_data.merchant_name = localStorage.getItem("merchant_name");
    } */

  },
  watch: {
    "other_data.longtime_radio": {
      handler(nradio, oradio) {
        if (nradio == "1") {
          this.mcoupon_data.start_time = GetDateTime(-1, new Date());
          this.mcoupon_data.expire_time = "2099-01-01 08:00:00";
        } else if (nradio == "0") {
          this.mcoupon_data.start_time = GetDateTime(0, new Date());
          this.mcoupon_data.expire_time = GetDateTime(7, new Date());
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    stockTypeChange(e) { },
    radioChange(e, key) {
      console.log(e, key);
    },
    //上传图片返回
    getReturn(res) {
      //   console.log("返回值",res)
      switch (res.tag) {
        case "logo":
          //
          this.mcoupon_data.display_pattern_info.merchant_logo_url = res.imgsrc;
          break;
      }
    },
    //删除图片返回
    returnClose(res) {
      switch (res.tag) {
        case "logo":
          this.mcoupon_data.display_pattern_info.merchant_logo_url = "";
          break;
      }
    },

    async createCoupon() {
      /*  */
      var that = this;
      this.mcoupon_data.amount = Number(
        this.mcoupon_data.coupon_use_rule.fixed_normal_coupon.amount
      );
      this.mcoupon_data.coupon_use_rule.fixed_normal_coupon.amount_require = Number(
        this.mcoupon_data.coupon_use_rule.fixed_normal_coupon
          .amount_require
      );
      this.mcoupon_data.stock_send_rule.max_coupons = Number(
        this.mcoupon_data.stock_send_rule.max_coupons
      );
      this.mcoupon_data.stock_send_rule.max_coupons_per_user = Number(
        this.mcoupon_data.stock_send_rule.max_coupons_per_user
      );

      this.mcoupon_data.out_request_no =
        "1601011649" + this.getDateStr() + this.RandomStr(9);
      if (this.mcoupon_data.stock_type === "NORMAL") {
        delete this.mcoupon_data.coupon_use_rule.discount_coupon;
      } else if (this.mcoupon_data.stock_type === "DISCOUNT") {
        delete this.mcoupon_data.coupon_use_rule.fixed_normal_coupon;
      }
      const res = await createWxMCoupon(that.mcoupon_data);
      console.log("返回值：", res);

      if (
        res.data.return_code == "SUCCESS" &&
        res.data.result_code == "SUCCESS"
      ) {
        this.successMessage("创建商家卷成功");
        setTimeout(async () => {
          var code_list = [];
          const str = this.RandomStr(7);
          for (let a = 0; a < 200; a++) {
            let code = str + (200 + a);
            code_list.push(code);
          }
          const result = await upLoadWxCode(
            JSON.parse(res.data.resp_data).stock_id,
            {
              coupon_code_list: code_list,
              upload_request_no:
                "1601011649" + this.getDateStr() + this.RandomStr(9)
            }
          );
          console.log("上传code：", result);
          this.$emit("createShopCoupon", "");
        }, 60000);
      } else if (res.data.return_code == "FAIL" && res.data.return_msg) {
        this.warnMessage(res.data.return_msg);
      } else if (res.data.result_code == "FAIL" && res.data.result_msg) {
        this.warnMessage(res.data.result_msg);
      }
      return;
    },
    getDate(date, str) {
      this.mcoupon_data[str] = this.formatDate(date, true);
    }
  }
};
</script>
<style scoped>
.el-form {
  color: #9d9fa5;
}

#date-div>>>.el-input {
  width: 200px !important;
}

.el-form-item>>>.el-input {
  width: 300px !important;
}

.el-divider--horizontal {
  height: 0.1px;
  margin-top: 5px !important;
  margin-right: 30px !important;
  margin-bottom: 0 !important;
}

.count-input {
  display: inline-block;
  width: 100px !important;
}
</style>
